import { cva, VariantProps } from "class-variance-authority";
import { cn } from "utils";

const buttonStyles = cva(
  "inline-flex items-center gap-x-2 font-medium whitespace-nowrap transition duration-300 rounded-lg",
  {
    variants: {
      variant: {
        primary:
          "bg-primary hover:bg-primary-600 border border-transparent text-white",
        secondary: "border border-primary text-primary-500 background",
        tertiary:
          "border border-secondary-200 bg-white text-secondary-600 shadow-xs",
        link: "border-transparent hover:text-primary-600",
        ghost: "border-transparent text-primary-600 hover:text-primary-800",
        warning: "text-white bg-system-warning hover:bg-system-warning/90",
        danger: "text-white bg-system-error hover:bg-system-error/90",
        success: "text-white bg-system-success hover:bg-system-success/90",
      },
      size: {
        small: "py-2 px-4 text-xs",
        medium: "py-3 px-4 text-sm",
        large: "py-3 px-4 text-base",
      },
      disabled: {
        true: "opacity-50 pointer-events-none",
        false: "",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "medium",
    },
  },
);

export type ButtonStyleProps = VariantProps<typeof buttonStyles>;

export const getButtonClasses = ({
  variant,
  size,
  disabled,
  className,
}: ButtonStyleProps & { className?: string }) => {
  return cn(
    buttonStyles({
      variant,
      size,
      disabled,
    }),
    className,
  );
};
